import * as React from 'react';

import classNames from 'classnames';

interface IFieldProps {
	isGrouped?: boolean;
	isHorizontal?: boolean;
	isExpanded?: boolean;
	isPulledRight?: boolean;
	isPulledLeft?: boolean;
	hasAddons?: boolean;
	hasAddonsRight?: boolean;
	className?: string;
}

export default class Field extends React.Component<IFieldProps, {}> {
	public render() {
		const {
			className,
			isGrouped,
			isHorizontal,
			isExpanded,
			hasAddons,
			hasAddonsRight,
			isPulledRight,
			isPulledLeft,
		} = this.props;

		const classes = classNames(
			'field',
			isGrouped ? 'is-grouped' : '',
			isHorizontal ? 'is-horizontal' : '',
			isExpanded ? 'is-expanded' : '',
			isPulledRight ? 'is-pulled-right' : '',
			isPulledLeft ? 'is-pulled-left' : '',
			hasAddons ? 'has-addons' : '',
			hasAddonsRight ? 'has-addons-right' : '',
			className ? className : ''
		);

		return <div className={classes}>{this.props.children}</div>;
	}
}
